import { useAuth } from "./AuthContext";

export type AdminPermission = "admin:read" | "admin:write" | "admin:manage";

export function usePermissions() {
  const { permissions } = useAuth();
  const perms = permissions || [];

  const hasPermission = (perm: AdminPermission): boolean =>
    perms.includes(perm);

  return {
    permissions: perms,
    canRead: hasPermission("admin:read"),
    canWrite: hasPermission("admin:write"),
    canManage: hasPermission("admin:manage"),
    hasPermission,
  };
}
